import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/cache.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm cache add <package-spec>
npm cache clean [<key>]
npm cache ls [<name>@<version>]
npm cache verify
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/cache.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`Used to add, list, or clean the npm cache folder.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`add:
Add the specified packages to the local cache.  This command is primarily
intended to be used internally by npm, but it can provide a way to
add data to the local installation cache explicitly.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`clean:
Delete all data out of the cache folder.  Note that this is typically
unnecessary, as npm's cache is self-healing and resistant to data
corruption issues.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`verify:
Verify the contents of the cache folder, garbage collecting any unneeded
data, and verifying the integrity of the cache index and all cached data.`}</p>
      </li>
    </ul>
    <h3>{`Details`}</h3>
    <p>{`npm stores cache data in an opaque directory within the configured `}<inlineCode parentName="p">{`cache`}</inlineCode>{`,
named `}<inlineCode parentName="p">{`_cacache`}</inlineCode>{`. This directory is a
`}<a parentName="p" {...{
        "href": "http://npm.im/cacache"
      }}><inlineCode parentName="a">{`cacache`}</inlineCode></a>{`-based content-addressable cache that
stores all http request data as well as other package-related data. This
directory is primarily accessed through `}<inlineCode parentName="p">{`pacote`}</inlineCode>{`, the library responsible
for all package fetching as of npm@5.`}</p>
    <p>{`All data that passes through the cache is fully verified for integrity on
both insertion and extraction. Cache corruption will either trigger an
error, or signal to `}<inlineCode parentName="p">{`pacote`}</inlineCode>{` that the data must be refetched, which it will
do automatically. For this reason, it should never be necessary to clear
the cache for any reason other than reclaiming disk space, thus why `}<inlineCode parentName="p">{`clean`}</inlineCode>{`
now requires `}<inlineCode parentName="p">{`--force`}</inlineCode>{` to run.`}</p>
    <p>{`There is currently no method exposed through npm to inspect or directly
manage the contents of this cache. In order to access it, `}<inlineCode parentName="p">{`cacache`}</inlineCode>{` must be
used directly.`}</p>
    <p>{`npm will not remove data by itself: the cache will grow as new packages are
installed.`}</p>
    <h3>{`A note about the cache's design`}</h3>
    <p>{`The npm cache is strictly a cache: it should not be relied upon as a
persistent and reliable data store for package data. npm makes no guarantee
that a previously-cached piece of data will be available later, and will
automatically delete corrupted contents. The primary guarantee that the
cache makes is that, if it does return data, that data will be exactly the
data that was inserted.`}</p>
    <p>{`To run an offline verification of existing cache contents, use `}<inlineCode parentName="p">{`npm cache
verify`}</inlineCode>{`.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`cache`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: Windows: `}<inlineCode parentName="li">{`%LocalAppData%\\npm-cache`}</inlineCode>{`, Posix: `}<inlineCode parentName="li">{`~/.npm`}</inlineCode></li>
      <li parentName="ul">{`Type: Path`}</li>
    </ul>
    <p>{`The location of npm's cache directory. See `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-cache"
      }}><inlineCode parentName="a">{`npm
cache`}</inlineCode></a></p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/folders"
        }}>{`npm folders`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-publish"
        }}>{`npm publish`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-pack"
        }}>{`npm pack`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://npm.im/cacache"
        }}>{`https://npm.im/cacache`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://npm.im/pacote"
        }}>{`https://npm.im/pacote`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://npm.im/@npmcli/arborist"
        }}>{`https://npm.im/@npmcli/arborist`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://npm.im/make-fetch-happen"
        }}>{`https://npm.im/make-fetch-happen`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      